export const SubscriptionCardsPage = {
  en: {
    Subscriptions: 'Subscriptions',
    'No subscriptions available': 'No subscriptions available',
  },
  uk: {
    Subscriptions: 'Підписки',
    'No subscriptions available': 'Підписки відсутні',
  },
};

export const SubscriptionCardPage = {
  en: {
    Cost: 'Cost',
    Visits: 'Visits',
    Validity: 'Validity',
    Renewal: 'Renewal',
    Discount: 'Discount',
    'Renews automatically': 'Charged automatically every month',
    'Unlimited visits': 'Unlimited visits',
    visits_one: '{{count}} visit',
    visits_other: '{{count}} visits',
    cardDays_one: '{{count}} day',
    cardDays_other: '{{count}} days',
    discountUses_one: 'up to {{count}} use',
    discountUses_other: 'up to {{count}} uses',
    Subscribe: 'Subscribe',
    'Subscribe till': 'You can subscribe until {{date}}',
    'Resubscribe at old price till':
      'You can return to this subscription at its current price until {{date}}',
    'Start service required': 'A start service is required',
    'Start service explanation':
      'To sign up for this subscription you first need to buy «{{name}}» for {{price}}.',
    'Start service awaiting activation':
      'You have already bought «{{name}}». Activate it at the club — after that you will be able to subscribe.',
    'Buy start service': 'Buy the start service',
    'Subscribe dialog title': 'Subscription sign-up',
    'Subscribe dialog description':
      'You are signing up for «{{name}}». {{price}} will be charged every month until you cancel the subscription.',
    'Subscribe failed': 'Could not start the sign-up. Please try again.',
    'Start service dialog title': 'Start service purchase',
    'Start service dialog description':
      'You are buying «{{name}}» for {{price}}. This is a one-off payment.',
    'Start service purchase failed':
      'Could not start the purchase. Please try again.',
    'Redirect to payment notice':
      'You will be redirected to the payment provider page.',
  },
  uk: {
    Cost: 'Вартість',
    Visits: 'Відвідування',
    Validity: 'Термін дії',
    Renewal: 'Поновлення',
    Discount: 'Знижка',
    'Renews automatically': 'Списання автоматично щомісяця',
    'Unlimited visits': 'Без обмеження відвідувань',
    visits_one: '{{count}} відвідування',
    visits_few: '{{count}} відвідування',
    visits_many: '{{count}} відвідувань',
    cardDays_one: '{{count}} день',
    cardDays_few: '{{count}} дні',
    cardDays_many: '{{count}} днів',
    discountUses_one: 'до {{count}} використання',
    discountUses_few: 'до {{count}} використань',
    discountUses_many: 'до {{count}} використань',
    Subscribe: 'Підписатися',
    'Subscribe till': 'Підписатися можна до {{date}}',
    'Resubscribe at old price till':
      'Ви можете повернутися до цієї підписки за поточною ціною до {{date}}',
    'Start service required': 'Потрібна стартова послуга',
    'Start service explanation':
      'Щоб оформити цю підписку, спочатку придбайте «{{name}}» за {{price}}.',
    'Start service awaiting activation':
      'Ви вже придбали «{{name}}». Активуйте її в клубі — після цього можна буде оформити підписку.',
    'Buy start service': 'Придбати стартову послугу',
    'Subscribe dialog title': 'Оформлення підписки',
    'Subscribe dialog description':
      'Ви оформлюєте підписку «{{name}}». {{price}} списуватиметься щомісяця, доки ви не скасуєте підписку.',
    'Subscribe failed':
      'Не вдалося розпочати оформлення. Спробуйте ще раз, будь ласка.',
    'Start service dialog title': 'Купівля стартової послуги',
    'Start service dialog description':
      'Ви купуєте «{{name}}» за {{price}}. Це разовий платіж.',
    'Start service purchase failed':
      'Не вдалося розпочати покупку. Спробуйте ще раз, будь ласка.',
    'Redirect to payment notice':
      'Вас буде перенаправлено на сторінку платіжного сервісу.',
  },
};
